import appSettings from "../../settings/appSettings";
import { Say } from "../../languages";

export function PaymentFirstHeader() {
  const { allowMultipleQuantity } = appSettings;

  if (allowMultipleQuantity) {
    return (
      <div className="app-max-mobile-component margin-bottom-base">
        <h2 className="zeta bold-text app-max-mobile-center margin-zero">
          <Say phrase="multiple_enabled.select_quantity_heading" />
        </h2>
      </div>
    );
  }

  return (
    <div className="app-max-mobile-component margin-bottom-base">
      <h2 className="zeta bold-text app-max-mobile-center margin-zero">
        <Say phrase="payment_first.select_payment_method" />
      </h2>
    </div>
  );
}
